/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementFilterForCombinationDto } from './TrackItMeasurementFilterForCombinationDto';
import {
    TrackItMeasurementFilterForCombinationDtoFromJSON,
    TrackItMeasurementFilterForCombinationDtoFromJSONTyped,
    TrackItMeasurementFilterForCombinationDtoToJSON,
} from './TrackItMeasurementFilterForCombinationDto';
import type { ISystemSetupCombinationValue } from './ISystemSetupCombinationValue';
import {
    ISystemSetupCombinationValueFromJSON,
    ISystemSetupCombinationValueFromJSONTyped,
    ISystemSetupCombinationValueToJSON,
} from './ISystemSetupCombinationValue';
import type { IConditionValueAssignment } from './IConditionValueAssignment';
import {
    IConditionValueAssignmentFromJSON,
    IConditionValueAssignmentFromJSONTyped,
    IConditionValueAssignmentToJSON,
} from './IConditionValueAssignment';

/**
 * 
 * @export
 * @interface CreateParameterCombinationDto
 */
export interface CreateParameterCombinationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    combinationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    hash?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateParameterCombinationDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    targetSystemId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateParameterCombinationDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {Array<ISystemSetupCombinationValue>}
     * @memberof CreateParameterCombinationDto
     */
    targetSystemValues?: Array<ISystemSetupCombinationValue> | null;
    /**
     * 
     * @type {Array<ISystemSetupCombinationValue>}
     * @memberof CreateParameterCombinationDto
     */
    supportSystemValues?: Array<ISystemSetupCombinationValue> | null;
    /**
     * 
     * @type {Array<IConditionValueAssignment>}
     * @memberof CreateParameterCombinationDto
     */
    readonly conditionValueAssignments?: Array<IConditionValueAssignment> | null;
    /**
     * 
     * @type {Array<TrackItMeasurementFilterForCombinationDto>}
     * @memberof CreateParameterCombinationDto
     */
    trackItFilters?: Array<TrackItMeasurementFilterForCombinationDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationDto
     */
    $type?: CreateParameterCombinationDtoTypeEnum;
}


/**
 * @export
 */
export const CreateParameterCombinationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsCreateParameterCombinationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.CreateParameterCombinationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateParameterCombinationDtoTypeEnum = typeof CreateParameterCombinationDtoTypeEnum[keyof typeof CreateParameterCombinationDtoTypeEnum];



/**
 * Check if a given object implements the CreateParameterCombinationDto interface.
 */
export function instanceOfCreateParameterCombinationDto(value?: unknown): value is CreateParameterCombinationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateParameterCombinationDtoTypeEnum)[0];
}

export function CreateParameterCombinationDtoFromJSON(json: any): CreateParameterCombinationDto {
    return CreateParameterCombinationDtoFromJSONTyped(json, false);
}

export function CreateParameterCombinationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateParameterCombinationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'combinationId': json['combinationId'] == null ? undefined : json['combinationId'],
        'hash': json['hash'] == null ? undefined : json['hash'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'supportSystemEntityIds': json['supportSystemEntityIds'] == null ? undefined : json['supportSystemEntityIds'],
        'targetSystemValues': json['targetSystemValues'] == null ? undefined : ((json['targetSystemValues'] as Array<any>).map(ISystemSetupCombinationValueFromJSON)),
        'supportSystemValues': json['supportSystemValues'] == null ? undefined : ((json['supportSystemValues'] as Array<any>).map(ISystemSetupCombinationValueFromJSON)),
        'conditionValueAssignments': json['conditionValueAssignments'] == null ? undefined : ((json['conditionValueAssignments'] as Array<any>).map(IConditionValueAssignmentFromJSON)),
        'trackItFilters': json['trackItFilters'] == null ? undefined : ((json['trackItFilters'] as Array<any>).map(TrackItMeasurementFilterForCombinationDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateParameterCombinationDtoToJSON(value?: Omit<CreateParameterCombinationDto, 'conditionValueAssignments'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'combinationId': value['combinationId'],
        'hash': value['hash'],
        'isEnabled': value['isEnabled'],
        'targetSystemId': value['targetSystemId'],
        'supportSystemEntityIds': value['supportSystemEntityIds'],
        'targetSystemValues': value['targetSystemValues'] == null ? undefined : ((value['targetSystemValues'] as Array<any>).map(ISystemSetupCombinationValueToJSON)),
        'supportSystemValues': value['supportSystemValues'] == null ? undefined : ((value['supportSystemValues'] as Array<any>).map(ISystemSetupCombinationValueToJSON)),
        'trackItFilters': value['trackItFilters'] == null ? undefined : ((value['trackItFilters'] as Array<any>).map(TrackItMeasurementFilterForCombinationDtoToJSON)),
        '$type': value['$type'],
    });
}

